"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrder = void 0;
const _ = require("lodash");
const updateOrder = async (supabase, order) => {
    const obj = _.cloneDeep(order);
    delete obj.reference; //generated column can't be used
    delete obj.client;
    delete obj.quotes;
    delete obj.created_by_user;
    delete obj.assigned_to_user;
    delete obj.snapshots;
    delete obj.order_lines;
    delete obj.reminders;
    delete obj.transactions;
    delete obj.agent;
    delete obj.payment_requests;
    delete obj.variants;
    obj.updated_at = new Date();
    const { data, error } = await supabase.from("orders").upsert(obj).single();
    if (error) {
        console.log("error", error);
        throw new Error(error.message);
    }
    return data;
};
exports.updateOrder = updateOrder;
